import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './ServicesSection.scss';

const ServicesSection: React.FC = () => {
  return (
    <section className="services-section">
      <Container>
        <Row className="justify-content-center">
          <Col md={8}>
            <Row className="mb-4">
              <Col className="text-center">
                <h2 className="section-title">Nuestro Núcleo</h2>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col className="text-center">
                <p className="section-text">
                  Entendemos que cada negocio es único, y por eso creamos soluciones diseñadas para satisfacer tus necesidades específicas.
                  Nuestro objetivo es ayudarte a alcanzar tus metas empresariales simplificando procesos, optimizando flujos de trabajo y proporcionando el soporte que necesitas para tener éxito.
                  Ya sea automatizando tareas, mejorando la eficiencia o escalando tus operaciones, creamos aplicaciones que empoderan a tu empresa para prosperar.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      
      <div className="divider-container">
        <hr className="custom-divider" />
      </div>
    </section>
  );
};

export default ServicesSection;